(function() {
    const contrastBtnEl = document.querySelector('.jsAccessibilityContrast');

    if (contrastBtnEl) {
        document.addEventListener('click', e => {
            if (e.target.classList.contains('jsAccessibilityContrast')) {
                e.preventDefault();
                toggleContrast();
            }

            if (e.target.classList.contains('jsAccessibilityFontSize')) {
                e.preventDefault();
                toggleFontSize();
            }
        });
    }

    // Check if there are any cookies
    const contrastCookie = getCookie('ab_contrast');
    if (contrastCookie === 'on') document.documentElement.classList.add('ab-contrast');
    
    const fontSizeCookie = getCookie('ab_font_size');
    if (fontSizeCookie) { document.documentElement.classList.add(fontSizeCookie); }

    // Functions
    function toggleContrast() {
        const date = new Date();
        date.setTime(date.getTime() + (99 * 24 * 60 * 60 * 1000));

        document.documentElement.classList.toggle('ab-contrast');
        document.cookie = 'ab_contrast=' + (document.documentElement.classList.contains('ab-contrast') ? 'on' : 'off') + '; expires=' + date.toGMTString() + '; path=/';
    }

    function toggleFontSize() {
        const date = new Date();
        date.setTime(date.getTime() + (99 * 24 * 60 * 60 * 1000));

        if (document.documentElement.classList.contains('ab-font-size-1')) {
            document.documentElement.classList.remove('ab-font-size-1');
            document.documentElement.classList.add('ab-font-size-2');
            document.cookie = 'ab_font_size=ab-font-size-2; expires=' + date.toGMTString() + '; path=/';
        }
        else if (document.documentElement.classList.contains('ab-font-size-2')) {
            document.documentElement.classList.remove('ab-font-size-2');
            document.cookie = 'ab_font_size=ab-font-size-0; expires=' + date.toGMTString() + '; path=/';
        }
        else {
            document.documentElement.classList.remove('ab-font-size-0');
            document.documentElement.classList.add('ab-font-size-1');
            document.cookie = 'ab_font_size=ab-font-size-1; expires=' + date.toGMTString() + '; path=/';
        }
    }

    function getCookie(c_name) {
        let c_value = " " + document.cookie;
        let c_start = c_value.indexOf(" " + c_name + "=");

        if (c_start == -1) {
            c_value = null;
        }
        else {
            var c_end = c_value.indexOf(";", c_start);
            c_start = c_value.indexOf("=", c_start) + 1;

            if (c_end == -1) c_end = c_value.length;
            c_value = unescape(c_value.substring(c_start,c_end));
        }

        return c_value;
    }
})();
